import { Notify } from 'quasar'
import { useCheckVersion } from '../../composables/useCheckVersion'
import { Capacitor } from '@capacitor/core'
import { computed, ref } from 'vue'
import { App } from '@capacitor/app'

/**
 * Pushes errors to a boot error log to display in a notification to the user.
 * Android/Browser specific messages are shown.
 * @param error any
 */
export const bootErrorMessage = (error: any, options: { stage: string }) => {
  if (Capacitor.isNativePlatform()) {
    androidNotify(error, options.stage)
  } else {
    browserNotify(error, options.stage)
  }
}

/**List of errors sent back from the boot process */
const errors = ref<string[]>([])
/**Returns list of errors rendered for html */
const errList = computed(() => {
  return errors.value.join(', ')
})
const errMess = computed(() => {
  return `An error ocurred during boot stages: <br /> [${errList.value}]
    `
})
const errMessageActive = ref(false)
/**
 * Android specific notification (allows rep to update app)
 * @param error any
 */
const androidNotify = async (error: any, stage: string) => {
  errors.value.push(stage)
  const version = (await App.getInfo()).version
  const notification = Notify.create({
    type: 'negative',
    timeout: 0,
    actions: [
      {
        noDismiss: true,
        color: 'white',
        label: 'Update to a new version',
        handler: async () => {
          const { checkAvailable, getAPK } = useCheckVersion()
          await checkAvailable()
          await getAPK()
        },
      },
      {
        icon: 'close',
        color: 'white',
        // for individual action (button):
        'aria-label': 'Dismiss',
      },
    ],
    position: 'bottom',
    multiLine: true,
    html: true,
    message: errMess.value,
    caption: `If this problem persists contact your manager or technical support.
    <br />Version: ${version}`,
  })
  if (!errMessageActive.value) {
    notification()
    errMessageActive.value = true
  } else {
    notification({ message: errMess.value })
  }
}

/**
 * Browser specific notification
 * @param error any
 */
const browserNotify = (error: any, stage: string) => {
  const notification = Notify.create({
    type: 'negative',
    timeout: 0,
    position: 'bottom',
    multiLine: true,
    html: true,
    message: errMess.value,
    caption: 'If this problem persists contact your manager or technical support.',
    actions: [
      {
        icon: 'close',
        color: 'white',
        // for individual action (button):
        'aria-label': 'Dismiss',
      },
    ],
  })
  errors.value.push(stage)
  if (!errMessageActive.value) {
    notification()
    errMessageActive.value = true
  } else {
    notification({ message: errMess.value })
  }
}
